<template>
  <div class="fff">
    <div class="timeAll_w">
      <el-date-picker
        v-model="value1"
        class="timeAll"
        type="daterange"
        disabled
        @change="getlist"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-dropdown disabled @command="handleCommand" class="timeDow">
        <span
          class="el-dropdown-link"
          :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
        >
          {{ $t("Last days Days", { days: days })  }}<i
            class="el-icon-caret-bottom el-icon--right"
            :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="7">{{$t('photos.num1')}}</el-dropdown-item>
          <el-dropdown-item command="30">{{$t('photos.num2')}}</el-dropdown-item>
          <el-dropdown-item command="60">{{$t('photos.num3')}}</el-dropdown-item>
          <el-dropdown-item command="90">{{$t('photos.num4')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div ref="imgbody" id="imgbody">
      <div class="photos_li" v-for="(val, key) in list" :key="key">
        <div class="img">
          <el-image
            :src="val.url"
            :preview-src-list="[val.url]"
            :initial-index="1"
          >
          </el-image>
        </div>
        <div class="time">
          {{ val.createtime }}
          <img @click="download(val.url)" src="@/assets/img/download.png" />
        </div>
      </div>
    </div>
    <div class="noData" v-if="list.length <= 0 && status">{{$t('photos.no')}}</div>
    <div class="pagination" v-if="code > 0">
      <el-pagination
        @current-change="setPage"
        :page-size="key.limit"
        background
        layout="prev, pager, next"
        :total="code"
      >
      </el-pagination>
    </div>
    <!-- <div class="photos_li">
    <div class="img">
      <img src="@/assets/img/my_avatar.png">
    </div>
    <div class="time">Apr 5, 2021 10:20 AM
      <img src="@/assets/img/download.png">
    </div>
  </div> -->
  </div>
</template>

<script>
import { Photo } from '@/api/user'
import {downloadFilePic } from '@/api/getUrlBase64';
export default {
  name: 'HelloWorld',
  data () {
    return {
      days: 7,
      key: {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 36,
        starttime: '',
        endtime: ''
      },
      code: 0,
      value1: '', // 获取时间
      list: [],
      msg: '',
      isChecked: null,
      status: false
    }
  },
  mounted () {
    let imgw = 220
    this.$nextTick(() => {
      let hCount = (this.$refs.imgbody.clientWidth - 17) / imgw
      let imgh = 3
      console.log(hCount)
      this.key.limit = imgh * parseInt(hCount)
      this.handleCommand()
    })
    window.addEventListener('resize', () => {
      this.$nextTick(() => {
        let hCount = (this.$refs.imgbody.clientWidth - 17) / imgw
        let imgh = 3
        this.key.limit = imgh * parseInt(hCount)
        this.handleCommand()
      })
    })
  },
  methods: {
    handleCommand (event) {
      // let end = new Date()
      let start = new Date(2021, 0, 1);
      let end = new Date(2022,3,30);
      if (event) {
        this.days = event
        start = new Date()
        this.isChecked = true
        start.setTime(start.getTime() - 3600 * 1000 * 24 * event)
      }
      this.value1 = [start, end]
      console.log(this.value1)
      this.getlist()
    },
    download (imgUrl) {
      // getUrlBase64(imgUrl).then((base64) => {
      //   let link = document.createElement('a')
      //   link.href = base64
      //   link.download = 'syplix_photos.png'
      //   link.click()
      // })
      downloadFilePic(imgUrl);
    },
    setPage (e) {
      this.key.page = e
      this.getlist()
    },
    getlist (a) {
      this.status = false
      this.key.starttime =
        this.value1[0].getFullYear() +
        '-' +
        (this.value1[0].getMonth() < 9 ? '0' : '') +
        (this.value1[0].getMonth() + 1) +
        '-' +
        (this.value1[0].getDate() < 10 ? '0' : '') +
        this.value1[0].getDate()
      this.key.endtime =
        this.value1[1].getFullYear() +
        '-' +
        (this.value1[1].getMonth() < 9 ? '0' : '') +
        (this.value1[1].getMonth() + 1) +
        '-' +
        (this.value1[1].getDate() < 10 ? '0' : '') +
        this.value1[1].getDate()
      console.log(this.key)
      if (a) {
        this.key.page = a
      }
      this.list = []
      Photo(this.key).then((adj) => {
        this.list = adj.data.list
        this.code = adj.data.count
        this.status = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}
.photos_li {
  /* float: left; */
  display: inline-block;
  background: #fff;
  -webkit-box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  width: 200px;
  height: 250px;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
  overflow: hidden;
}
.photos_li .img {
  width: 200px;
  height: 200px;
  overflow: hidden;
}
.photos_li .img img {
  width: 200px;
  height: 200px;
}
.photos_li .time {
  height: 50px;
  line-height: 50px;
  text-indent: 13px;
  font-size: 12px;
  color: #3f3f3f;
  overflow: hidden;
}
.photos_li .time img {
  height: 16px;
  width: 16px;
  float: right;
  margin: 17px 10px 0 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Photos.vue